import { clipboardIcon } from '@workday/canvas-system-icons-web'
import { canvasIconPaths } from '~/icons/canvasIconPaths'
import { createIcon } from './create-icon'

export const Paste = createIcon({
  viewBox: '0 0 24 24',
  displayName: 'Paste',
  paths: canvasIconPaths(clipboardIcon)
})
